export default __webpack_public_path__ + "img/screenshot_1.863e2cb5.png";